import * as XLSX from "xlsx";

export const exportExcel = ({
    data,
    columns,
    fileName = "Export",
    sheetName = "Sheet1",
}) => {
    
    const rows = data.map(item => {
        const row = {};

        columns.forEach(col => {
            row[col.label] = item[col.key];
        });

        return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        sheetName
    );

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};